<script>
export default {
  name: 'KanboardFrame',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      error: null,
    };
  },
  methods: {
    onLoad() {
      this.isLoading = false;
      this.error = null;
      this.$emit('loaded');
    },
    onError(event) {
      this.isLoading = false;
      this.error =
        'Não foi possível conectar ao Kanboard. Verifique se o serviço está rodando.';
      this.$emit('error', this.error);
    },
    reload() {
      this.isLoading = true;
      this.error = null;

      // forçar reload do iframe
      if (this.$refs.kanboardIframe) {
        this.$refs.kanboardIframe.src = this.url + '?t=' + Date.now();
      }
    },
  },
};
</script>

<template>
  <div class="kanboard-frame-container">
    <!-- Loading State -->
    <div v-if="isLoading" class="loading-container">
      <div class="loading-content">
        <div class="spinner" />
        <p>Carregando Kanboard...</p>
      </div>
    </div>

    <!-- Error State -->
    <div v-if="error" class="error-container">
      <div class="error-content">
        <div class="error-icon">⚠️</div>
        <h3>Erro ao carregar Kanboard</h3>
        <p>{{ error }}</p>
        <button class="btn btn-primary" @click="reload">
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Iframe -->
    <iframe
      v-show="!isLoading && !error"
      ref="kanboardIframe"
      :src="url"
      class="kanboard-iframe"
      @load="onLoad"
      @error="onError"
    />
  </div>
</template>

<style scoped>
.kanboard-frame-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
}

.kanboard-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.loading-container,
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #f8f9fa;
}

.loading-content,
.error-content {
  text-align: center;
  padding: 2rem;
}

.spinner {
  width: 3rem;
  height: 3rem;
  border: 0.25rem solid #e9ecef;
  border-top: 0.25rem solid #3182ce;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-content h3 {
  color: #e53e3e;
  margin-bottom: 0.5rem;
}

.error-content p {
  color: #718096;
  margin-bottom: 1.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #3182ce;
  color: white;
}

.btn-primary:hover {
  background: #2c5aa0;
}

/* Responsivo */
@media (max-width: 768px) {
  .kanboard-iframe {
    height: calc(100vh - 140px);
  }

  .loading-content,
  .error-content {
    padding: 1rem;
  }
}
</style>
